export default __webpack_public_path__ + "images/models/82ef182587b034c28b2c6639345ddb07.usdz";